import React, { lazy } from 'react';
import { ArrowRight, Star, ShieldCheck, Flame } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  return <section id="offer" className="bg-gradient-to-b from-pilates-sage-dark to-pilates-dark py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-140">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-pilates-lavender/15 rounded-full blur-3xl pointer-events-none" data-id="element-141"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-142">
        <div className="bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-143">
          SPECIAL OFFER — COMPLETE 6-IN-1 PACK
        </div>
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-white leading-tight mb-4 tracking-tight" data-id="element-144">
          Access the system now and transform your classes{' '}
          <span className="italic text-pilates-cream" data-id="element-145">today</span>
        </h2>

        <div className="mb-8 max-w-md mx-auto mt-10" data-id="element-146">
          <img src="https://cdn.magicpatterns.com/uploads/jR6ACrFLYMAhNeVC3xJcD8/hf_20260602_221642_f266517f-2571-4aed-9d07-491b68f8c948_(1).webp" alt="Pilates Ready 6-in-1 Box Set" className="w-full rounded-2xl shadow-2xl" loading="lazy" decoding="async" width="800" height="800" data-id="element-147" />
        </div>

        <div id="pricing-card" className="bg-white rounded-3xl p-6 sm:p-8 shadow-2xl max-w-md mx-auto scroll-mt-8" data-id="element-148">
          <p className="text-pilates-slate text-sm mb-1" data-id="element-149">
            Normal Price: <span className="line-through" data-id="element-150">$97 USD</span>
          </p>

          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white text-xs font-bold px-3 py-1.5 rounded-full my-3 uppercase tracking-wide" data-id="element-151">
            <Flame className="w-4 h-4" data-id="element-152" /> 80% OFF — Launch Offer
          </div>

          <p className="text-pilates-slate text-sm mb-1" data-id="element-153">Limited Time Price:</p>
          <p className="font-display text-6xl sm:text-7xl font-semibold text-pilates-rose mb-1 leading-none" data-id="element-154">
            $19 USD
          </p>
          <p className="text-pilates-slate text-xs mb-4" data-id="element-155">
            Pay in your local currency
          </p>

          <p className="text-pilates-rose font-semibold text-sm mb-5 flex items-center justify-center gap-1" data-id="element-156">
            🔥 Last chance! The price increases when the timer ends.
          </p>

          <div className="mb-6" data-id="element-157">
            <CountdownTimer data-id="element-158" />
          </div>

          <a href="https://pilates-ready.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="group w-full bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white font-semibold text-base sm:text-lg py-4 px-6 rounded-full shadow-[0_10px_30px_rgba(201,123,99,0.4)] hover:shadow-[0_15px_40px_rgba(201,123,99,0.6)] hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-3" data-id="element-159">
            <span data-id="element-160">🚀 YES, I WANT THE 6-IN-1 PACK ($19)</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-161" />
          </a>

          <div className="mt-5 flex flex-col items-center gap-2" data-id="element-162">
            <div className="flex items-center gap-2" data-id="element-163">
              <div className="flex text-pilates-rose" data-id="element-164">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-165" />)}
              </div>
              <span className="text-pilates-slate text-sm font-medium" data-id="element-166">
                4.9/5 — Verified Reviews
              </span>
            </div>
            <div className="flex items-center gap-2 text-pilates-slate text-sm" data-id="element-167">
              <ShieldCheck className="w-4 h-4 text-pilates-sage-dark" data-id="element-168" />
              <span data-id="element-169">7-Day Guarantee — Zero Risk</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}